import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import setting from '../../../config/setting'
import Button from '@material-ui/core/Button'
import {styles} from '../../CSS/Styles';
import CustomizedLineChart from '../../CSSComponent/linechart'
import { KRIAlertChartDataFormationRainfallSourceDetail} from '../../SharedComponents/KRIAlertChartDataFormation'
import Typography from '@material-ui/core/Typography';
import {connect} from 'react-redux'
import {
  aRainfallData
} from '../../../redux/actions'
import config from '../../../config/config'
import axios from 'axios';
import DropDownList from '../../CSSComponent/dropdownselection'



class rainfall_reading extends Component {
    intervalID = 0;

    constructor(props) {
        super(props)
        this.state = {
            detail_station_name: 'S105 Admiralty Road West ',
        }
    }

    componentWillMount() {

        this.intervalID = setInterval(() => {
            this.getRainfallData();
            console.log("fetch update rain fall data")
        }, 300000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }
    //                
    componentDidMount() {
        this.getRainfallData()
    }

    getRainfallData() {
        axios.get(config.rainfalldata).then((res) => {
            console.log(res)
            this.props.dRainfallData(res.data)
        })
    }
    returnSelection = (id, name, index ) => {
        console.log(id, name, index)
        this.setState({ detail_station_name: name})
    }

    reshap_array() {
        let tempdata = [].concat(...this.props.rainfall_data)
        let data = []
        for (let row = 0; row < this.props.rainfall_data[0].length; row++) {
            let rowdata = []
            for (let col = 0; col < this.props.rainfall_data.length; col++) {
                rowdata.push(tempdata[row + this.props.rainfall_data[0].length * col])
            }
            data.push(rowdata)
        }
        return data
    }

    render() {
        const { classes } = this.props
        if (this.props.rainfall_data[0] == 'rainfall data') {
            return(<div/>)
        }
        console.log(this.props.rainfall_data)

        let monitor_data = this.reshap_array()
        console.log(monitor_data)
        let station_data = []
        if (this.state.detail_station_name == '') {
            station_data = monitor_data[1]
        } else {
            monitor_data.map((arrayitem) => {
                if (arrayitem[0] == this.state.detail_station_name) {
                    station_data = arrayitem
                }
             })
        }
        console.log(station_data)

        let line_chart_data = KRIAlertChartDataFormationRainfallSourceDetail(station_data.slice(1), monitor_data[0].slice(1))

        return (
            <div>
                <CustomizedLineChart data={line_chart_data} title={[line_chart_data.risk_name, line_chart_data.kri_id + ' -- ' + line_chart_data.description, this.state.detail_station_name]} />
                <Button
                    variant='outlined'
                    color='primary'
                    className={classes.button}
                    style={{position:'absolute', top:'0px',left:'0px'}}
                    onClick={() => {
                        console.log('bakc')
                        this.props.back()
                    }}
                >
                    Back
                </Button>
                <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                    <DropDownList
                        defaultoption={0}
                        returnSelection={this.returnSelection}
                        option={this.props.rainfall_data[0].slice(1)}
                    />
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  // ... computed data from state and optionally ownProps
    return {
        rainfall_data: state.rainfall_data
    }
}

const mapDispatchToProps = dispatch => {
  // ... normally is an object full of action creators
    return {
      dRainfallData: (data) => { dispatch(aRainfallData(data)) }
    }
}

// `connect` returns a new function that accepts the component to wrap:
const connectToStore = connect(
  mapStateToProps,
  mapDispatchToProps
)

const ConnectedComponent = connectToStore(withStyles(styles)(rainfall_reading))
export default ConnectedComponent;


// WEBPACK FOOTER //
// ./src/components/Dashboard/KRIDashboardComponent/KRIRainfallReadingDetail.js